<div class="workorder-container">
    <div class="container-xl">
        <div class="workorder-header">
            <div class="header-buttons">
                <app-codalt-button icon="arrow-left" [text]="viaTicket ? 'Terug naar ticket' : 'Terug naar lijst'" [light]="true" (clicked)="onBackClick()"></app-codalt-button>
                @if(Features.WorkorderImages | hasFeature) {
                    <button mat-stroked-button
                            [routerLink]="['/', Routenames.WorkOrderImages]"
                            [queryParams]="{workorderId: workorder?.id}"
                            matTooltip="Bekijk alle afbeeldingen van deze werkorder">
                        <mat-icon>image</mat-icon>
                        Afbeeldingen
                    </button>
                }
                @if (Features.TtmTicketsSave | hasFeature) {
                    <button mat-stroked-button (click)="report()" [disabled]="!workorder" matTooltip="Meld een probleem met deze werkopdracht">
                        <mat-icon>live_help</mat-icon>
                        Melden
                    </button>
                }
            </div>

            <div class="workorder-content">
                <div class="workorder-info row-mobile">
                    <h1 class="title">{{workorder?.id_4ps}}</h1>
                    <h2 class="subtitle">{{workorder?.source_no}}</h2>
                    <h2 class="subtitle">{{workorder?.project?.id_4ps}}</h2>
                </div>
                <div class="workorder-info">
                    <p *ngIf="workorder?.started_date && !workorder?.finished_date" class="started time">
                        <i class="fa fa-play"></i>{{workorder?.started_date | codaltDate : 'EEEE d MMMM yyyy H:mm'}}
                    </p>

                    <p *ngIf="workorder?.started_date && workorder?.finished_date" class="finished time">
                        <i class="fa fa-check"></i>{{workorder?.started_date | codaltDate : 'EEEE d MMMM yyyy H:mm' :workorder?.finished_date}}
                    </p>
                    <p class="time">
                        {{workorder?.planned_startdate | codaltDate : 'EEEE d MMMM yyyy H:mm' : workorder?.planned_enddate}}
                    </p>
                    <h2 class="title">
                        {{workorder?.soort}}
                    </h2>
                    <i class="fa fa-sync cursor-pointer"
                       matTooltip="Herlaad werkopdracht"
                       [class.fa-spin]="loading"
                       (click)="loadWorkorder(workorderId)"></i>
                </div>
            </div>

            <div class="workorder-content">
                <div class="workorder-info row-mobile">
                    @if (Features.UsersSave | hasFeature) {
                        <app-codalt-chip class="clickable"
                                         [text]="workorder?.project?.projectmanager?.name || 'Geen uitvoerder aan deze werkopdracht gekoppeld'"
                                         [error]="!workorder?.project?.projectmanager"
                                         [dark]="true"
                                         routerLink="/{{Routenames.Users}}/{{workorder?.project?.projectmanager?.id}}"></app-codalt-chip>
                    } @else {
                        <app-codalt-chip [text]="workorder?.project?.projectmanager?.name || 'Geen uitvoerder aan deze werkopdracht gekoppeld'"
                                         [error]="!workorder?.project?.projectmanager"
                                         [dark]="true"></app-codalt-chip>
                    }

                    @if (Features.ShowSensetiveInformation | hasFeature) {
                        @for (user of workorder?.users; track $index) {
                            @if (Features.UsersSave | hasFeature) {
                                <app-codalt-chip class="clickable" [text]="user?.name || '?'" [light]="true"
                                                 routerLink="/{{Routenames.Users}}/{{user.id}}"></app-codalt-chip>
                            } @else {
                                <app-codalt-chip [text]="user?.name || '?'" [light]="true"></app-codalt-chip>
                            }
                        } @empty {
                            <app-codalt-chip text="Geen medewerkers aan deze werkopdracht gekoppeld." [light]="true"></app-codalt-chip>
                        }
                    }
                </div>
            </div>
        </div>

        <div class="workorder-header">
            <div class="workorder-content">
                <div class="workorder-info column">
                    <h1 class="title">{{workorder?.project?.name}}</h1>
                    <p class="description">{{workorder?.description}}</p>
                </div>
            </div>
        </div>
        <div class="workorder-files">

            <div class="list-container">
                <h1 class="title icon">
                    <i class="fa fa-paperclip"></i> Bijlagen
                    <div class="flex-fill"></div>
                    <i class="fa fa-sync cursor-pointer"
                       matTooltip="Synchroniseer de bijlagen met 4PS"
                       [class.fa-spin]="syncing"
                       (click)="importAttachments()"
                       *ngIf="Features.WorkordersImportAttachmentsSave | hasFeature"></i>
                </h1>

                <div class="file-list">
                    @if (!attachments()) {
                        <i class="far fa-spinner-third fa-spin fa-2x"></i>
                    }
                    @for (attachment of attachments(); track $index) {
                        <div class="attachment" (click)="file(attachment)">
                            <div><i [class]="'far fa-file-' + fileExtension(attachment.filename)"></i> {{attachment.filename}}</div>
                            @if (attachment.loading) {
                                <i class="far fa-spinner-third fa-spin"></i>
                            } @else {
                                <i class="fa fa-eye"></i>
                            }
                        </div>
                    } @empty {
                        @if (attachments()) {
                            <div class="drawing error not-clickable">
                                <i class="far fa-warning"></i>
                                <p>Er zijn geen bijlagen voor deze werkopdracht beschikbaar</p>
                            </div>
                        }
                    }
                </div>

            </div>
            <div class="list-container">
                <h1 class="title icon">
                    <i class="fa fa-map-location-dot"></i> Tekeningen

                    <div class="flex-fill"></div>

                    <a routerLink="/{{Routenames.Drawings}}"
                       [queryParams]="{'search' : 'P:' + workorder?.project_id}"
                       *ngIf="Features.DrawingsPaginated | hasFeature"
                       matTooltip="Tekeningen"
                       matTooltipPosition="after">
                        <i class="fa fa-draw-polygon"></i>
                    </a>
                </h1>

                <div class="file-list">
                    @if (!drawings()) {
                        <i class="far fa-spinner-third fa-spin fa-2x"></i>
                    }

                    @for (drawing of drawings(); track $index) {
                        <div class="drawing"
                             (click)="goToDrawing(workorder.project_id, drawing.drawing.id)"
                             [class.not-clickable]="drawing.drawing?.entities_count === 0">
                            <div>
                                <h2 class="title">{{drawing.drawing?.filename}} ({{drawing.drawing?.revision}})</h2>
                                <p class="description">{{drawing.drawing?.name}}</p>
                                <div class="time finished">{{drawing.drawing?.date | codaltDate : 'EEEE d MMMM yyyy'}}</div>
                            </div>
                            @if (drawing.drawing?.error_at) {
                                <div>
                                    <div class="drawing error">
                                        <i class="far fa-warning"></i>
                                        <p>
                                            {{drawing.drawing.error}}
                                            <br>
                                            <small>{{drawing.drawing.error_at | codaltDate : 'EEEE d MMMM yyyy H:mm'}}</small>
                                        </p>
                                    </div>
                                </div>
                            } @else if (drawing.drawing?.entities_count > 0) {
                                <div>
                                    <i class="fa fa-external-link"></i>
                                </div>
                            } @else {
                                <div>
                                    <div class="drawing error">
                                        <i class="far fa-warning"></i>
                                        <p>Tekening is niet geïmporteerd</p>
                                    </div>
                                </div>
                            }
                        </div>
                    } @empty {
                        @if (notASingleDrawingWithEntities) {
                            <div class="drawing error not-clickable">
                                <i class="far fa-warning"></i>
                                <p>De app is niet bruikbaar voor deze werkopdracht omdat er geen enkele geconverteerde tekening aan het project van deze
                                    werkopdracht gekoppeld is</p>
                            </div>
                        } @else if (drawings() && workorder) {
                            <div class="drawing error not-clickable">
                                <i class="far fa-warning"></i>
                                <p>Er zijn geen tekeningen aan deze werkopdracht gekoppeld</p>
                            </div>
                        }
                    }
                </div>
            </div>
        </div>
    </div>
</div>
<div class="workorder-footer">
    <div class="container-xl">
        <div class="footer-content">
            @if (workorder?.ttms_count) {
                <app-codalt-chip text="{{workorder?.ttms_mutated_count}} / {{workorder?.ttms_count}}" icon="traffic-cone"></app-codalt-chip>
            } @else {
                <div class="error">
                    <i class="far fa-traffic-cone"></i> Er zijn geen maatregelen aan deze werkopdracht gekoppeld
                </div>
            }

            @if (workorder?.ttms_count) {
                <app-codalt-chip matRipple class="cursor-pointer" text="{{workorder?.ttms_with_comment_count}} / {{workorder?.ttms_count}}" icon="comment" [error]="workorder.ttms_with_comment_count > 0" (click)="openWithRemarkFilter()"></app-codalt-chip>
            }

            <div class="buttons">
                <app-codalt-button [disabled]="notASingleDrawingWithEntities"
                                   icon="pen"
                                   *ngIf="Features.WorkordersTtmsSave | hasFeature"
                                   text="Bewerk werkopdracht"
                                   (clicked)="onPenClick()">
                </app-codalt-button>
                <app-codalt-button [dark]="true"
                                   icon="play"
                                   text="Werkopdracht {{(Features.TtmsUpdateStatusSave | hasFeature) ? 'uitvoeren' : 'bekijken'}}"
                                   [disabled]="notASingleDrawingWithEntities"
                                   (clicked)="executeWorkorder()">
                </app-codalt-button>
            </div>
        </div>
    </div>
</div>
